import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import type { CityObjectReportFileListItemType } from "../types/CityObjectReportFile";

const baseUrl = "/api/CityObjectReportFiles";

async function authHeader(): Promise<Record<string, string>> {
  const token = await getApiAccessToken();
  return { Authorization: `Bearer ${token}` };
}

export const listCityObjectReportFiles = async (
  addressSystemId: number,
  currentUserId: number,
): Promise<CityObjectReportFileListItemType[]> => {
  const headers = await authHeader();
  const response = await apiClient.get(
    `${baseUrl}/${addressSystemId}/list`,
    { headers, params: { currentUserId } },
  );
  return response.data as CityObjectReportFileListItemType[];
};

export const listCityObjectReportFileGroups = async (
  addressSystemId: number,
  currentUserId: number,
): Promise<string[]> => {
  const headers = await authHeader();
  const response = await apiClient.get(
    `${baseUrl}/${addressSystemId}/groups`,
    { headers, params: { currentUserId } },
  );
  return response.data as string[];
};

export const uploadCityObjectReportFile = async (
  addressSystemId: number,
  params: {
    file: File;
    fileGroup: string;
    fileHeader: string;
    contractIds: number[];
  },
  currentUserId: number,
): Promise<{ id: number }> => {
  const headers = await authHeader();
  const fd = new FormData();
  fd.append("file", params.file);
  fd.append("fileGroup", params.fileGroup);
  fd.append("fileHeader", params.fileHeader);
  fd.append("contractIds", params.contractIds.join(","));
  fd.append("currentUserId", String(currentUserId));
  const response = await apiClient.post(
    `${baseUrl}/${addressSystemId}/upload`,
    fd,
    { headers },
  );
  return response.data as { id: number };
};

export const downloadCityObjectReportFileBlob = async (
  addressSystemId: number,
  fileId: number,
  currentUserId: number,
): Promise<{ blob: Blob; filename: string }> => {
  const headers = await authHeader();
  const response = await apiClient.get(
    `${baseUrl}/${addressSystemId}/download/${fileId}`,
    {
      headers,
      params: { currentUserId },
      responseType: "blob",
    },
  );
  const cd = response.headers["content-disposition"] as string | undefined;
  let filename = "download";
  if (cd) {
    const m = /filename\*?=(?:UTF-8'')?["']?([^"';]+)/i.exec(cd);
    if (m) filename = decodeURIComponent(m[1].trim());
  }
  return { blob: response.data as Blob, filename };
};

export const deleteCityObjectReportFile = async (
  addressSystemId: number,
  fileId: number,
  currentUserId: number,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.delete(`${baseUrl}/${addressSystemId}/${fileId}`, {
    headers,
    params: { currentUserId },
  });
};
